import * as React from 'react'

interface IPencilProps {
  className?: string
}

const Pencil = ({ className = 'icon' }: IPencilProps) => (
  <svg
    className={'icon ' + className}
    width='22'
    height='22'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.86019 7.86156L4.08859 10.0899C4.18875 10.19 4.33898 10.19 4.43913 10.0899L9.99763 4.50657C10.0978 4.40643 10.0978 4.2562 9.99763 4.15605L7.79426 1.95278C7.69411 1.85263 7.54388 1.85263 7.44373 1.95278L1.86019 7.53607C1.76003 7.63622 1.76003 7.78645 1.86019 7.86156ZM8.51918 0.926376C8.41903 1.02653 8.41903 1.17675 8.51918 1.2769L10.7226 3.48017C10.8227 3.58032 10.9729 3.58032 11.0731 3.48017L11.699 2.85424C12.0997 2.47868 12.0997 1.87779 11.699 1.47719L10.5222 0.300446C10.1216 -0.100149 9.49567 -0.100149 9.09506 0.300446L8.51918 0.926376ZM0.00702947 11.5671C-0.0430471 11.8175 0.182298 12.0428 0.43268 11.9928L3.16185 11.3418C3.26201 11.3168 3.33712 11.2667 3.3872 11.2166L3.43728 11.1665C3.48735 11.1165 3.51239 10.9412 3.41224 10.8411L1.15879 8.58771C1.05864 8.48757 0.88337 8.5126 0.833293 8.56268L0.783217 8.61275C0.708102 8.68786 0.683063 8.76297 0.658025 8.83809L0.00702947 11.5671Z'
      fill='#8C97A2'
    />
  </svg>
)

export default Pencil



// WEBPACK FOOTER //
// ./src/components/icons/ui/Pencil.tsx